export const questions = {
    "quizTitle": "Chestionar verificare pe parcurs",
    "quizSynopsis": "Lucrător calificat în culturi de câmp şi legumicultură",
    "progressBarColor": "#9de1f6",
    "nrOfQuestions": "182",
    "appLocale": {
        "landingHeaderText": "<questionLength> Intrebari",
        "question": "Intrebare",
        "startQuizBtn": "Incepe",
        "resultFilterAll": "Toate",
        "resultFilterCorrect": "Correct",
        "resultFilterIncorrect": "Incorect",
        "prevQuestionBtn": "Inapoi",
        "nextQuestionBtn": "Inainte",
        "multipleSelectionTagText": "Selectie multipla",
        "resultPageHeaderText": "Ai terminat. Ai <correctIndexLength> raspunsuri corecte din <questionLength> total.",
        "pickNumberOfSelection": "Alege <numberOfSelection>",
        "marksOfQuestion": "(<marks> puncte)"
    },
    "questions": [
        {
            "question": "1. Specii de grâu ce se foloseste pentru panificatie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grâul comun",
                "b) grâul semitare",
                "c) grâul durum"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "2. Ce tip de semănători se folosesc pentru semănatul plantelor prăşitoare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Semănători de precizie",
                "b) Semănători în rânduri",
                "c) Semănători prin împrăştiere"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "3. Plante bune premergatoare pentru porumb:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) floarea soarelui, porumbul, sfecla de zahar, plante furajere",
                "b) cereale paioase, leguminoase anuale si perene, inul, cartofii",
                "c) porumbul, ricinul, cerealele, inul"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "4. Ce se întelege prin combaterea integrată a bolilor şi dăunătorilor plantelor cultivate:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Folosirea mijloacelor agrotehnice şi chimice",
                "b) Folosirea mijloacelor agrotehnice, fizico-mecanice, biologice şi chimice",
                "c) Folosirea mijloacelor fizico-mecanice şi chimice"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "5. Este necesară efectuarea instructajului muncitorilor privind protecţia muncii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da, pentru evitarea accidentelor de muncă şi folosirea corectă a utilajelor",
                "b) nu",
                "c) doar dacă vrea muncitoru"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "6. Arătura cu scormonitorul are rolul de a:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sparge harponul de 5 – 10 cm format în timp",
                "b) de a întoarce mai bine brazda",
                "c) de a executa o uniformitate mai bună a arăturii"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "7. Când se pot aplica îngrăşăminte chimice la culturile de câmp:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) înainte de semănat, odată cu semănatul şi în timpul vegetaţiei",
                "b) înainte de semănat",
                "c) în timpul vegetaţiei"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "8. Prin ce metode se înfiinţează culturile care se înmulţesc prin diferite părţi vegetative specifice (tuberculi, bulbi, etc.):",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manual",
                "b) mecanizat",
                "c) ambele metode"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "9. Fertilizarea organica a porumbului se face cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) gunoi de grajd",
                "b) azotat de amoniu",
                "c) superfosfat"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "10. Recoltarea şi depozitarea cerealelor pentru sămânţă se face la umiditatea de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 18 – 20 %",
                "b) 20 – 22 %",
                "c) sub 15 %"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "11. Care sunt sursele de poluare chimică a solului în agricultură:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îngrăşămintele chimice",
                "b) pesticidele",
                "c) ambele"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "12. Care sunt materialele de plantat:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) seminte, arpagic, bulbi, tuberculi, rasad",
                "b) bulbi",
                "c) stoloni"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "13. Care sunt principalii factori de vegetaţie necesari creşterii şi dezvoltării plantelor agricole:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura, lumina şi elementele nutritive",
                "b) apa şi aerul",
                "c) toţi factorii menţionaţi"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "14. Reglarea turaţiei la toba combinei la recoltat paioase se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la începutul campaniei",
                "b) seara",
                "c) de câte ori este nevoie"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "15. Care sunt metodele utilizate pentru combaterea buruienilor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) preventive",
                "b) curative",
                "c) ambele"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "16. Care din următoarele tipuri de sol au fertilitatea cea mai ridicată:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bălane",
                "b) cernoziomul",
                "c) brun roşcate"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "17. Momentul aplicării erbicidelor este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) înainte de însămânţarea sau plantarea",
                "b) după pământ sau plantat şi în vegetaţie (după răsărit)",
                "c) toate aceste momente în funcţie de felul erbicidului, cultură, vârsta buruienilor prezente etc."
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "18. Stimularea germinării seminţelor de legume prin diferite procedee se face cu scopul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) încolţirea în condiţii mai puţin favorabile de temperatură şi umiditate",
                "b) scoaterea seminţelor din starea de repaus şi grăbirea încolţirii lor",
                "c) sporirea facultăţii germinative"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "19. Poluarea mediului ambiant, după natura poluanţilor poate fi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poluare fizică şi chimică",
                "b) poluare biologică şi „estetică\" (degradarea peisajelor)",
                "c) toate aceste categorii de poluare"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "20. Care dintre următoarele măsuri de combatere a bolilor şi dăunătorilor este considerată măsură agrotehnică:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stropirea cu insectofungicide",
                "b) cultivarea de soiuri rezistente la boli şi dăunători",
                "c) tratamente termice la sămânţă"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "21. Care este metoda cea mai ieftină de reducere a umidităţii producţiei de seminţe:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) termică – cu ajutorul instalaţiei termice",
                "b) solarizarea naturală a produselor",
                "c) asigurarea luminozităţii în magazie"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "22. Pentru combaterea bolilor şi dăunătorilor plantelor cultivate se aplică:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tratamente preventive",
                "b) tratamente curative",
                "c) tratamente preventive şi curative"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "23. Ce contine ingrasamintele N P K 20:20:20:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) azot, fosfor, potasiu",
                "b) azot",
                "c) fosfor"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "24. Care este metoda de irigare cea mai avantajoasă (economică) în cultura plantelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin picurare",
                "b) prin aspersiune",
                "c) prin scurgere la suprafaţă (brazde)"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "25. Cum se realizează recoltarea la majoritatea legumelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) printr-o singură trecere",
                "b) prin mai multe treceri, eşalonat (selectiv) la maturitatea de consum",
                "c) prin 1-2 treceri"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "26. În ce constă sortarea manuală a produselor agricole:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îndepărtarea impurităţilor",
                "b) separarea produselor corespunzătoare de cele necorespunzătoare (mici, crăpate, vătămate cu defecte, etc.)",
                "c) alegerea după mărime şi greutate"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "27. Masurile preventive in combaterea bolilor si daunatorilor sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) fertilizarea echilibrata",
                "b) cultivarea soiurilor rezistente, respectarea rotatiei, distrugerea samulastrei, asigurarea densitatii",
                "c) combaterea prin tratamente în vegetatie"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "28. Ambalarea legumelor obţinute în gospodăria proprie în vederea valorificării se realizează în:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lădiţe (lăzi) de diferite tipuri, coşuri, saci, săculeţi din material plastic",
                "b) lăzi de lemn",
                "c) paleţi"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "29. Care este adâncimea de semănat a porumbului:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 4-6 cm",
                "b) 5-8 cm",
                "c) 8-10 cm"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "30. Cum se realizează călirea răsadurilor de legume:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin reducerea treptată a temperaturii şi umidităţii cu 10-15 zile înainte de plantare",
                "b) prin sistarea fertilizării şi intensificarea aerisirii",
                "c) prin toate aceste măsuri"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "31. Pregătirea magaziilor pentru depozitarea produselor se face prin:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) izolare termică a magaziilor",
                "b) văruit şi dezinfectat magaziile",
                "c) asigurarea luminozităţii în magazii"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "32. Principalele elemente nutritive (macroelemente) de care au nevoie plantele de cultură:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) azot, fosfor, potasiu",
                "b) carbon, hidrogen, oxigen",
                "c) calciu, magneziu, sulf"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "33. Specii de grâu ce se foloseste pentru panificatie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grâul comun",
                "b) grâul semitare",
                "c) grâul durum"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "34. Soiurile de grâu care se cultiva in vestul tarii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ariesan, Turda 81, Fundulea 4",
                "b) Dropia, Gabriela, Flamura",
                "c) Lovrin 34, Lovrin 41, Alex, Dropia"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "35. Plante bune premergatoare pentru floarea soarelui:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cânepa, tutun, soia, fasole, rapita",
                "b) lucerna, sfecla, sorg, iarba de sudan",
                "c) cereale paioase, mazare, porumb neerbicidat cu triazine"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "36. Gândacul de Colorado are la cartof:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1 generatie",
                "b) 2 generatii",
                "c) mai multe generatii"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "37. Ce tip de semănători se folosesc pentru semănatul plantelor prăşitoare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Semănători de precizie",
                "b) Semănători în rânduri",
                "c) Semănători prin împrăştiere"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "38. Plante bune premergatoare pentru porumb:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) floarea soarelui, porumbul, sfecla de zahar, plante furajere",
                "b) cereale paioase, leguminoase anuale si perene, inul, cartofii",
                "c) porumbul, ricinul, cerealele, inul"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "39. Înfrătirea la cereale este influenţata de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) epoca de semanat, adâncimea si desimea la semanat",
                "b) utilajul folosit la semanat",
                "c) sămânţă tratată"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "40. Reglarea turaţiei la toba combinei la recoltat paioase se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la începutul campaniei",
                "b) seara",
                "c) de câte ori este nevoie"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "41. Porumbul se însămânţează la adâncimea de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3-6 cm",
                "b) 6-10 cm",
                "c) 10-15 cm"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "42. Epoca optima de semanat la orz este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 10-25 septembrie",
                "b) 25 septembrie - 5 octombrie",
                "c) 5 – 15 octombrie"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "43. Maşinile pentru administrat îngrăşăminte minerale (chimice) solide sunt alcătuite din:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Cadru, rezervor, pompă centrifugă, marcatoare de urmă",
                "b) Cadru, buncăr, exhaustor, dozator",
                "c) Cadru, buncăr, dozatoare, aparate de distribuţie"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "44. Cum se poate defini procesul de lucru efectuat cu un agregat de arat?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Desprinderea, răsturnarea şi deplasarea laterală a unui strat de sol",
                "b) Deschiderea unei rigole si deplasarea laterală a solului",
                "c) Desprinderea unui strat superficial de sol concomitent cu răvăşirea acestuia"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "45. Cum se numeşte organul de lucru al plugurilor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Cuţit disc",
                "b) Trupiţă",
                "c) Sapă rotativă"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "46. Ce se întelege prin combaterea integrată a bolilor şi dăunătorilor plantelor cultivate:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Folosirea mijloacelor agrotehnice şi chimice",
                "b) Folosirea mijloacelor agrotehnice, fizico-mecanice, biologice şi chimice",
                "c) Folosirea mijloacelor fizico-mecanice şi chimice"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "47. Este necesară efectuarea instructajului muncitorilor privind protecţia muncii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da, pentru evitarea accidentelor de muncă şi folosirea corectă a utilajelor",
                "b) nu",
                "c) doar dacă vrea muncitorul"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "48. Arătura cu scormonitorul are rolul de a:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sparge harponul de 5 – 10 cm format în timp",
                "b) de a întoarce mai bine brazda",
                "c) de a executa o uniformitate mai bună a arăturii"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "49. Care sunt principalii factori de vegetaţie necesari creşterii şi dezvoltării plantelor agricole:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura, lumina şi elementele nutritive",
                "b) apa şi aerul",
                "c) toţi factorii menţionaţi"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "50. Precizaţi care dintre următoarele îngrăşăminte este natural:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ureea",
                "b) mraniţa",
                "c) borax"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "51. Când se pot aplica îngrăşăminte chimice la culturile de câmp:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) înainte de semănat, odată cu semănatul şi în timpul vegetaţiei",
                "b) înainte de semănat",
                "c) în timpul vegetaţiei"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "52. Prin ce metode se înfiinţează culturile care se înmulţesc prin diferite părţi vegetative specifice (tuberculi, bulbi, etc.):",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manual",
                "b) mecanizat",
                "c) ambele metode"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "53. Atacul de plosnitele cerealelor influienteaza calitatea boabelor de grâu prin:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) diminuarea calitatii glutenului",
                "b) cresterea greutatii hectolitrice",
                "c) cresterea umiditatii"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "54. Care sunt principalele metode de aplicare a îngrăşămintelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin împrăştiere şi în benzi",
                "b) odată cu apa de irigare şi prin stropirea culturilor cu soluţii diluate de îngrăşăminte chimice",
                "c) prin toate aceste metode"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "55. Fertilizarea organica a porumbului se face cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) gunoi de grajd",
                "b) azotat de amoniu",
                "c) superfosfat"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "56. Recoltarea şi depozitarea cerealelor pentru sămânţă se face la umiditatea de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 18 – 20 %",
                "b) 20 – 22 %",
                "c) sub 15 %"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "57. Care sunt sursele de poluare chimică a solului în agricultură:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îngrăşămintele chimice",
                "b) pesticidele",
                "c) ambele"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "58. Care sunt adăposturile folosite în legumicultură:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) folie întinsă şi adăposturi înalte (solarii)",
                "b) folie întinsă (fără susţinere), adăposturi joase (tunele joase) şi adăposturi înalte (solarii)",
                "c) adăposturi înalte (solarii) şi adăposturi joase (tunele joase)"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "59. Care sunt uneltele utilizate la plantarea manuală pe suprafeţe mici:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) săpăliga, sapa, lingura de plantat sau plantatorul",
                "b) lingura de plantat sau săpăliga",
                "c) plantatorul, sapa"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "60. Care sunt materialele de plantat:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) seminte, arpagic, bulbi, tuberculi, rasad",
                "b) bulbi",
                "c) stoloni"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "61. Care sunt principalele elemente meteorologice:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura aerului, temperatura solului, umiditatea aerului, umiditatea solului",
                "b) temperatura aerului",
                "c) umiditatea"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "62. Care sunt insusirile solului:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) textura, structura",
                "b) textura",
                "c) structura"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "63. Care sunt principalii factori de vegetaţie necesari creşterii şi dezvoltării plantelor agricole:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura, lumina şi elementele nutritive",
                "b) apa şi aerul",
                "c) toţi factorii menţionaţi"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "64. Plante bune premergatoare pentru porumb:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) floarea soarelui, porumbul, sfecla de zahar, plante furajere",
                "b) cereale paioase, leguminoase anuale si perene, inul, cartofii",
                "c) porumbul, ricinul, cerealele, inul"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "65. Înfrătirea la cereale este influenţata de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) epoca de semanat, adâncimea si desimea la semanat",
                "b) utilajul folosit la semanat",
                "c) sămânţă tratată"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "66. Reglarea turaţiei la toba combinei la recoltat paioase se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la începutul campaniei",
                "b) seara",
                "c) de câte ori este nevoie"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "67. Porumbul se însămânţează la adâncimea de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3-6 cm",
                "b) 6-10 cm",
                "c) 10-15 cm"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "68. Care este rolul echipamentului de lucru al tractoarelor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cuplarea şi acţionarea (în unele cazuri) a maşinilor agricole cu care tractorul lucrează în agregat",
                "b) efectuarea de lucrări prin acţionarea roţilor motoare",
                "c) angrenarea unui arbore motor în timpul lucrului"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "69. Prin ce metode se înfiinţează culturile care se înmulţesc prin tuberculi, bulbi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manual",
                "b) mecanizat",
                "c) ambele metode"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "70. Care sunt metodele utilizate pentru combaterea buruienilor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) preventive",
                "b) curative",
                "c) ambele"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "71. Care din următoarele tipuri de sol au fertilitatea cea mai ridicată:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bălane",
                "b) cernoziomul",
                "c) brun roşcate"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "72. Momentul aplicării erbicidelor este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) înainte de însămânţarea sau plantarea",
                "b) după pământ sau plantat şi în vegetaţie (după răsărit)",
                "c) toate aceste momente în funcţie de felul erbicidului, cultură, vârsta buruienilor prezente etc."
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "73. Atacul de plosnitele cerealelor influienteaza calitatea boabelor de grâu prin:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) diminuarea calitatii glutenului",
                "b) cresterea greutatii hectolitrice",
                "c) cresterea umiditatii"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "74. Fertilizarea organica a porumbului se face cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) gunoi de grajd",
                "b) azotat de amoniu",
                "c) superfosfat"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "75. Care sunt metodele de semănat în răsadniţe şi sere înmulţitor în vederea obţinerii răsadurilor de legume:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin împrăştiere",
                "b) în rânduri",
                "c) prin împrăştiere sau în rânduri"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "76. Stimularea germinării seminţelor de legume prin diferite procedee se face cu scopul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) încolţirea în condiţii mai puţin favorabile de temperatură şi umiditate",
                "b) scoaterea seminţelor din starea de repaus şi grăbirea încolţirii lor",
                "c) sporirea facultăţii germinative"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "77. Înfiinţarea culturilor legumicole în câmp se face prin:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) semănat direct în camp",
                "b) răsad",
                "c) plantarea materialului săditor (tuberculi, bulbi), răsad, semănat direct în câmp"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "78. Poluarea mediului ambiant, după natura poluanţilor poate fi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poluare fizică şi chimică",
                "b) poluare biologică şi „estetică\" (degradarea peisajelor)",
                "c) toate aceste categorii de poluare"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "79. Care dintre următoarele măsuri de combatere a bolilor şi dăunătorilor este considerată măsură agrotehnică:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stropirea cu insectofungicide",
                "b) cultivarea de soiuri rezistente la boli şi dăunători",
                "c) tratamente termice la sămânţă"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "80. Ce se înţelege prin combaterea integrantă a bolilor şi dăunătorilor plantelor cultivate:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) folosirea mijloacelor agrotehnice şi chimice",
                "b) folosirea mijloacelor agrotehnice, fizico-mecanice, biologice şi chimice",
                "c) folosirea mijloacelor fizico-mecanice şi chimice"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "81. Care este metoda cea mai ieftină de reducere a umidităţii producţiei de seminţe:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) termică – cu ajutorul instalaţiei termice",
                "b) solarizarea naturală a produselor",
                "c) asigurarea luminozităţii în magazie"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "82. Pentru combaterea bolilor şi dăunătorilor plantelor cultivate se aplică:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tratamente preventive",
                "b) tratamente curative",
                "c) tratamente preventive şi curative"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "83. Ce contine ingrasamintele N P K 20:20:20:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) azot, fosfor, potasiu",
                "b) azot",
                "c) fosfor"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "84. Care este metoda de irigare cea mai avantajoasă (economică) în cultura plantelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin picurare",
                "b) prin aspersiune",
                "c) prin scurgere la suprafaţă (brazde)"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "85. Care sunt principalele elemente meteorologice:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura aerului, temperatura solului, umiditatea aerului, umiditatea solului",
                "b) temperatura aerului",
                "c) umiditatea"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "86. Care sunt indicii de calitate a seminţelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) puritate, masa a 1000 de boabe",
                "b) puritate, germinaţie, masa hectolitrică, masa a 1000 de boabe",
                "c) germinaţie"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "87. Este necesară efectuarea instructajului muncitorilor privind protecţia muncii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da, pentru evitarea accidentelor de muncă şi folosirea corectă a utilajelor",
                "b) nu",
                "c) doar dacă vrea muncitorul"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "88. Cum se realizează recoltarea la majoritatea legumelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) printr-o singură trecere",
                "b) prin mai multe treceri, eşalonat (selectiv) la maturitatea de consum",
                "c) prin 1-2 treceri"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "89. Care legume se recoltează manual pe suprafeţe mici prin dizlocare cu furci sau cazmale:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ardei, vinete, varză",
                "b) ridichi de lună, ceapă verde, gulii",
                "c) morcov, pătrunjel, păstârnac"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "90. Aplicarea tratamentelor pentru combaterea bolilor şi dăunătorilor se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) preventiv",
                "b) curativ",
                "c) preventiv şi curative"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "91. În ce constă sortarea manuală a produselor agricole:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îndepărtarea impurităţilor",
                "b) separarea produselor corespunzătoare de cele necorespunzătoare (mici, crăpate, vătămate cu defecte, etc.)",
                "c) alegerea după mărime şi greutate"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "92. Care sunt maşinile şi instalaţiile de condiţionare a produselor agricole:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) maşini şi instalaţii simple cu site sau dispozitive de calibrat",
                "b) instalaţii de curăţat şi calibrat",
                "c) maşini de separare a corpurilor străine"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "93. Plante bune premergatoare pentru porumb:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) floarea soarelui, porumbul, sfecla de zahar, plante furajere",
                "b) cereale paioase, leguminoase anuale si perene, inul, cartofii",
                "c) porumbul, ricinul, cerealele, inul"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "94. Cum se realizează recoltarea la majoritatea legumelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) printr-o singură trecere",
                "b) prin mai multe treceri, eşalonat (selectiv) la maturitatea de consum",
                "c) prin 1-2 treceri"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "95. Fertilizarea organica a porumbului se face cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) gunoi de grajd",
                "b) azotat de amoniu",
                "c) superfosfat"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "96. Înfrătirea la cereale este influenţata de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) epoca de semanat, adâncimea si desimea la semanat",
                "b) utilajul folosit la semanat",
                "c) sămânţă tratată"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "97. Pentru combaterea bolilor şi dăunătorilor plantelor cultivate se aplică:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tratamente preventive",
                "b) tratamente curative",
                "c) tratamente preventive şi curative"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "98. Rolul principalelor elemente în nutritia grâului sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) azotul, fosforul, potasiul",
                "b) fosforul",
                "c) potasiul"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "99. Ingrasamintele cu fosfor si potasiu se aplica:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) numai sub aratura de baza",
                "b) în timpul vegetatiei",
                "c) la semanat"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "100. Masurile preventive in combaterea bolilor si daunatorilor sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) fertilizarea echilibrata",
                "b) cultivarea soiurilor rezistente, respectarea rotatiei, distrugerea samulastrei, asigurarea densitatii",
                "c) combaterea prin tratamente în vegetatie"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "101. Semanatul porumbului se realizeaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) când la ora 7, la 10 cm adâncime temperatura este 8 grade în crestere",
                "b) calendaristic 1- 20 februarie dupa zona",
                "c) în ambele cazuri"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "102. Hibrizii de porumb semanati in zona de vest:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Lovrin 400, NSSC 420, Andreea, Florencia",
                "b) Fundulea 420, Doina",
                "c) Rapsodia, Turda 200"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "103. Care este metoda de irigare cea mai avantajoasă (economică) în cultura plantelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin picurare",
                "b) prin aspersiune",
                "c) prin scurgere la suprafaţă (brazde)"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "104. Fertilizarea suplimentară (fazială) se execută:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la sol prin încorporare sau odată cu apa de irigaţie",
                "b) pe plante prin stropiri (foliar)",
                "c) prin ambele căi"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "105. Ce diferenta este între o sera şi un solar?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sera este încălzită iar solarul nu este încălzit",
                "b) sera are scheletul metalic, iar la solar scheletul este din lemn",
                "c) difernţe de înălţime"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "106. Ambalarea legumelor obţinute în gospodăria proprie în vederea valorificării se realizează în:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lădiţe (lăzi) de diferite tipuri, coşuri, saci, săculeţi din material plastic",
                "b) lăzi de lemn",
                "c) paleţi"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "107. Care sunt cele mai bune premergătoare pentru grâul de toamnă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) leguminoase pentru boabe, rapiţă",
                "b) porumb, sfeclă de zahăr",
                "c) floarea soarelui, cartofi de toamnă"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "108. Combaterea chimică împotriva complexului de boli foliare şi a dăunătorilor la cultura grâului:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este necesară, deoarece reprezintă o verigă importantă care asigură cantitatea şi calitatea producţiei",
                "b) nu are o influenţă prea mare asupra producţiei",
                "c) nu este obligatorie"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "109. Care sunt principalele boli ale culturii de floarea soarelui:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mana şi putregaiul cenuşiu",
                "b) mana, putregaiul alb, putregaiul cenuşiu, pătarea brună şi frângerea tulpinilor",
                "c) putregaiul alb, putregaiul cenuşiu, frângerea tulpinilor"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "110. Care sunt metodele de plantat:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manuala",
                "b) manuală, mecanizată, semimecanizată",
                "c) mecanizată"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "111. Care sunt principalele elemente meteorologice:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura aerului, temperatura solului, umiditatea aerului, umiditatea solului",
                "b) temperatura aerului",
                "c) umiditatea"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "112. Care sunt materialele de plantat:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) seminte, bulbi, tuberculi, răsad",
                "b) bulbi",
                "c) stoloni"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "113. Poluarea mediului ambiant, după natura poluanţilor poate fi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poluare fizică şi chimică",
                "b) poluare biologică şi „estetică\" (degradarea peisajelor)",
                "c) toate aceste categorii de poluare"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "114. Fasolea pentru boabe este sensibilă la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) umiditate în exces",
                "b) umiditate scăzută, temperaturi ridicate, secetă atmosferică",
                "c) în ambele situaţii, în perioada înfloritului şi formarea păstăilor"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "115. Care este adâncimea de semănat a porumbului:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 4-6 cm",
                "b) 5-8 cm",
                "c) 8-10 cm"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "116. Cum se realizează călirea răsadurilor de legume:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin reducerea treptată a temperaturii şi umidităţii cu 10-15 zile înainte de plantare",
                "b) prin sistarea fertilizării şi intensificarea aerisirii",
                "c) prin toate aceste măsuri"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "117. Principalul dăunător al fasolei este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) viermele sârmă",
                "b) gărgăriţa fasolei",
                "c) musca minieră"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "118. Cum se păstrează porumbul după recoltare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sub formă de ştiuleţi",
                "b) sub formă de boabe",
                "c) ambele forme, în funcţie de metoda de recoltare"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "119. Pregătirea magaziilor pentru depozitarea produselor se face prin:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) izolare termică a magaziilor",
                "b) văruit şi dezinfectat magaziile",
                "c) asigurarea luminozităţii în magazii"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "120. Rolul sortării produselor agricole este de a:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îndepărta resturile vegetale, uniformiza produsul, combaterea bolilor",
                "b) de a se pastra un timp mai îndelungat",
                "c) îi cresc calităţile produsului"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "121. Pentru evaluarea producţiei de cereale păioase se iau în calcul elementele:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) numărul de plante pe metru pătrat şi numărul mediu de spice pe o plantă",
                "b) numărul mediu de boabe în spic şi masa 1000 boabe (MMB)",
                "c) toate"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "122. Care sunt principalii factori de vegetaţie necesari creşterii şi dezvoltării plantelor agricole:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura, lumina şi elementele nutritive",
                "b) apa şi aerul",
                "c) toţi factorii menţionaţi"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "123. Semanatul porumbului se realizeaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) când la ora 7 la 10 cm adâncime temperatura este 8 grade în crestere",
                "b) calendaristic 1-20 februarie dupa zona",
                "c) în ambele cazuri"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "124. Care sunt metodele de irigare practicate în legumicultură:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Irigarea prin brazde, prin aspersiune şi prin picurare",
                "b) Irigarea prin brazde şi prin picurare",
                "c) Irigarea prin aspersiune"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "125. Principalele elemente nutritive (macroelemente) de care au nevoie plantele de cultură:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) azot, fosfor, potasiu",
                "b) mangan, sulf, calciu",
                "c) molibden, magneziu, calciu"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "126. Care dintre următoarele tipuri de sol au fertilitatea cea mai ridicată:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bălane",
                "b) cernoziomul",
                "c) brun-roşcat"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "127. Speci de grâu ce se foloseste pentru panificatie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grâul comun",
                "b) grâul semitare",
                "c) grâul durum"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "128. Îngrăşămintele ce se aplică plantelor de cultură sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îngrăşăminte organice",
                "b) chimice şi organice",
                "c) chimice (minerale)"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "129. Plante bune premergatoare pentru floarea soarelui:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cânepa, tutun, soia, fasole, rapita",
                "b) lucerna, sfecla, sorg, iarba de sudan",
                "c) cereale paioase, mazare, porumb neerbicidat cu triazine"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "130. Combaterea gargaritei la fasole se face la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) semanat",
                "b) maturitatea deplina",
                "c) inceputul înfloritului"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "131. Precizaţi care dintre următoarele îngrăşăminte este natural:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ureea",
                "b) mraniţa",
                "c) borax"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "132. Când se pot aplica îngrăşăminte chimice la culturile de câmp:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) înainte de semănat, odată cu semănatul şi în timpul vegetaţiei",
                "b) înainte de semănat",
                "c) în timpul vegetaţiei"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "133. Care sunt metodele de semănat la culturile de câmp:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în rânduri dese şi în rânduri distanţate",
                "b) în rânduri dese, în rânduri distanţate în benzi în rigole, pe biloane, etc.",
                "c) în rânduri rare şi în benzi"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "134. Care sunt uneltele utilizate la plantarea manuală pe suprafeţe mici:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) săpăliga, sapa, lingura de plantat sau plantatorul",
                "b) lingura de plantat sau săpăliga",
                "c) plantatorul, sapa"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "135. În vederea însilozării porumbului, care este faza optimă de recoltare a acestuia?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) înainte de legare",
                "b) când ştiuletele ajunge la maturitate",
                "c) când ştiuleţii sînt în faza de lapte – ceară"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "136. Care dintre următoarele măsuri de combatere a bolilor şi dăunătorilor este considerată măsură agrotehnică:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stropirea cu insectofungicide",
                "b) cultivarea de soiuri rezistente la boli şi dăunători",
                "c) tratamente termice la sămânţă"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "137. Sortarea manuală a produselor se face la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cereale păioase",
                "b) cartof, legume, fructe",
                "c) plante furajere"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "138. Ambalarea produselor agricole se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu scop comercial",
                "b) pentru protecţie împotriva dăunătorilor",
                "c) pentru depozitare mai îndelungată"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "139. Lucrările solului cu combinatorul au rolul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a conserva apa în sol",
                "b) de a nu conserva apa în sol",
                "c) de a distruge buruienile"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "140. Arătura cu scormonitorul are rolul de a:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sparge harponul de 5-10 cm format în timp",
                "b) de a întoarce mai bine brazda",
                "c) de a executa o uniformitate mai bună a arăturii"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "141. Pentru combaterea bolilor şi dăunătorilor plantelor cultivate se aplică:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tratamente preventive",
                "b) tratamente curative",
                "c) tratamente preventive şi curative"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "142. Cum se realizează recoltarea la majoritatea legumelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) printr-o singură trecere",
                "b) prin mai multe treceri, eşalonat (selectiv) la maturitatea de consum",
                "c) prin 1-2 treceri"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "143. Utilizarea pesticidelor în ecosistemele agricole, conform principiului protecţiei integrate a culturilor, presupune:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) folosirea numai dacă este necesar a celor potrivite şi sub un control riguros",
                "b) renunţarea la pesticide",
                "c) interzicerea utilizării pesticidelor"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "144. În ce constă sortarea manuală a produselor agricole:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îndepărtarea impurităţilor",
                "b) separarea produselor corespunzătoare de cele necorespunzătoare (mici, crăpate, vătămate cu defecte, etc.)",
                "c) alegerea după mărime şi greutate"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "145. Care este adâncimea de semănat a porumbului:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 4-6 cm",
                "b) 5-8 cm",
                "c) 8-10 cm"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "146. Fertilizarea organica a porumbului se face cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) gunoi de grajd",
                "b) azotat de amoniu",
                "c) superfosfat"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "147. Reglarea turaţiei la toba combinei la recoltat paioase se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la începutul campaniei",
                "b) seara",
                "c) de câte ori este nevoie"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "148. Înfrătirea la cereale este influenţata de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) epoca de semanat, adâncimea si desimea la semanat",
                "b) utilajul folosit la semanat",
                "c) sămânţă tratată"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "149. Porumbul se însămânţează la adâncimea de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3-6 cm",
                "b) 6-10 cm",
                "c) 10-15 cm"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "150. Epoca optima de semanat la orz este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 10-25 septembrie",
                "b) 25 septembrie - 5 octombrie",
                "c) 5 – 15 octombrie"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "151. Ce reprezintă culturile succesive de legume:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sistemul de cultură cu două culturi pe aceeaşi suprafaţă de teren, în timpul unui an",
                "b) sistemul de cultură a speciilor legumicole după plante furajere şi cereale care eliberează terenul devreme",
                "c) sistemul de cultură care permite ca, pe aceeaşi suprafaţă de teren, în timpul unui an, să se cultive două sau trei specii de legume, una după alta"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "152. La terminarea lucrării de semănat, semănătoarea se lasă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cuplată de tractor",
                "b) se decuplează semănătoarea de tractor",
                "c) indiferent"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "153. Un produs „bio\" este un produs pentru care:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu s-au folosit pesticide",
                "b) s-au folosit pesticide",
                "c) s-a folosit o cantitate mai mică de pesticide"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "154. Semănatul în vederea obţinerii răsadurilor de legume se poate face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în strat de amestec nutritiv şi în lădiţe",
                "b) în ghivece de diferite tipuri şi în palete alveolare",
                "c) în toate aceste moduri"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "155. După provenienţa lor în ecosistemele agricole productive, resursele pot fi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) naturale şi convenţionale",
                "b) naturale",
                "c) convenţionale"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "156. Care sunt măsurile care se iau pentru călirea răsadurilor de legume:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) expunerea progresivă la temperaturi apropiate din viitorul loc de cultură şi întreruperea fertilizărilor",
                "b) reducerea treptată a udărilor şi intensificarea aerisirilor",
                "c) toate aceste măsuri"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "157. Venitul unei ferme este reprezentat de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Valoarea producţiei principale + valoarea producţiei secundare",
                "b) Valoarea producţiei principale + subvenţii",
                "c) Valoarea producţiei principale + valoarea producţiei secundare + subvenţii"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "158. Dirijarea factorilor de mediu la culturile legumicole în solarii se referă la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dirijarea temperaturii şi umidităţii",
                "b) dirijarea temperaturii din aer şi sol, dirijarea luminii şi umidităţii relative a aerului",
                "c) dirijarea temperaturii şi compoziţiei aerului"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "159. Care sunt principalele boli la cultura de floarea soarelui:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Mana şi putregaiul cenuşiu",
                "b) Mana, putregaiul alb, putregaiul cenuşiu, pătarea brună şi frângerea tulpinilor",
                "c) Mana şi frângerea tulpinilor"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "160. Aplicarea tratamentelor pentru combaterea bolilor şi dăunătorilor se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) preventiv",
                "b) curativ",
                "c) preventiv şi curativ"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "161. Din punct de vedere agrotehnic, mazărea şi fasolea se apreciază ca fiind:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) foarte bune premergătoare pentru majoritatea speciilor legumicole",
                "b) bune premergătoare",
                "c) nu se recomandă ca plante premergătoare"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "162. Fungicidele folosite la combaterea agenţilor patogeni (boli) se aplică:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) preventiv (înainte sau în timpul pătrunderii în ţesutul plantei)",
                "b) curativ (după apariţia simptomelor atacului)",
                "c) atât preventiv cât şi curativ, prin alternanţa produselor"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "163. Care sunt adăposturile folosite în legumicultură:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) folie întinsă şi adăposturi înalte (solari si sere)",
                "b) folie întinsă (fără susţinere), adăposturi joase (tunele joase) şi adăposturi înalte (solaria si sere)",
                "c) adăposturi înalte (solaria si sere) şi adăposturi joase (tunele joase)"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "164. Care sunt uneltele specifice producerii răsadurilor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ciur, targa, termometru",
                "b) bătător, marcatoare, presă pentru cuburi nutritive, lădiţe etc.",
                "c) plantator, stropitoare, coşuri"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "165. Care sunt principalele metode de aplicare a ingrăşămintelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin împrăştiere şi în benzi",
                "b) odată cu apa de irigare şi prin stropirea culturilor cu soluţii diluate de îngrăşăminte chimice",
                "c) Prin toate aceste metode"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "166. Instalarea răsadniţei pentru producerea răsadurilor constă în succesiunea principalelor operaţiuni astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) aşezarea gunoiului de grajd în straturi şi călcarea, încălzirea cu apă fierbinte, introducerea amestecului nutritiv, aşezarea tocurilor şi acoperirea cu folie",
                "b) preîncălzirea gunoiului de grajd, aşezarea în straturi succesive şi călcarea uniformă, aşezarea tocurilor şi ferestrelor (ramelor), aşezarea stratului de amestec nutritiv",
                "c) răsfirarea şi călcarea gunoiului de grajd, aşezarea tocurilor, aşezarea amestecurilor, acoperirea cu folie"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "167. Care este lucrarea de combatere a buruienilor din cultura de grâu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) erbicidarea",
                "b) prăşitul",
                "c) irigarea"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "168. Ce lucrare execută tăvălugul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) seamănă",
                "b) tăvălugeşte",
                "c) arat"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "169. Care sunt indicii de calitate a seminţelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) puritate, masa a 1000 de boabe",
                "b) puritate, germinaţie, masa hectolitrică, masa a 1000 de boabe",
                "c) germinaţie"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "170. Ce conţin îngrăşămintele N P K 15:15:15:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) azot, fosfor, potasiu",
                "b) azot",
                "c) fosfor"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "171. Care sunt principalele elemente meteorologice:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura aerului, temperatura solului, umiditatea aerului, umiditatea solului",
                "b) temperatura solului",
                "c) umiditatea"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "172. Pentru cultura legumelor, cele mai indicate sunt următoarele tipuri de sol:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nisipoase",
                "b) argiloase",
                "c) nisipolutoase, lutonisipoase"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "173. Care sunt însuşirile solului:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) textura, structura",
                "b) textura",
                "c) structura"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "174. Care sunt distanţele de plantare la ardei gras în câmp:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 50 cm între rânduri şi 25-30 cm între plante pe rând",
                "b) 70 cm între rânduri şi 15-20 cm între plante pe rând",
                "c) 60 cm între rânduri şi 30-35 cm între plante pe rând"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "175. Care sunt principalele lucrări de îngrijire a culturilor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) combaterea buruienilor, combaterea bolilor, combaterea dăunătorilor, irigarea, fertilizarea suplimentară",
                "b) combaterea buruienilor",
                "c) combaterea dăunătorilor"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "176. Momentul recoltării la majoritatea legumelor este la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) maturitatea fiziologică",
                "b) maturitatea de consum",
                "c) înainte de maturitatea fiziologică"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "177. Care sunt metodele de plantat:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manuală",
                "b) manuală, mecanizată, semimecanizată",
                "c) semimecanizată"
            ],
            "correctAnswer": [
                2
            ]
        },
        {
            "question": "178. Semănatul porumbului se realizează:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) când la ora 7, la o adâncime de 10 cm în sol temperatura este de 8 grade în creştere",
                "b) calendaristic 1-20 februarie după zonă",
                "c) ambele cazuri"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "179. Susţinerea plantelor de tomate cultivate în solarii se face:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe spalier şi şnur de sfoară",
                "b) pe araci (tutori) individuali",
                "c) prin ambele procedee"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "180. Care sunt principalii factori de vegetaţie necesari creşterii şi dezvoltării plantelor agricole:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura, lumina şi elementele nutritive",
                "b) apa şi aerul",
                "c) toţi factorii menţionaţi"
            ],
            "correctAnswer": [
                3
            ]
        },
        {
            "question": "181. Ce erbicide se pot aplica pentru combaterea buruienilor din culturi în timpul vegetaţiei:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) erbicide de contact şi sistemice",
                "b) erbicide de contact",
                "c) erbicide sistemice"
            ],
            "correctAnswer": [
                1
            ]
        },
        {
            "question": "182. La locul de muncă, muncitorul trebuie sa aibă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) salopetă, cizme de cauciuc, mănuşi de protecţie",
                "b) salopetă",
                "c) pantofi"
            ],
            "correctAnswer": [
                1
            ]
        }
    ]
}
